import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  cloudChiprApi,
  GetUsersMeOrganisationsCurrentResourceExplorerFiltersByFilterProviderAndFilterTypeValuesApiArg,
} from "@/services/cloudchipr.api";

export const infrastructureArchitecturePossibleRegionsThunkArgs: GetUsersMeOrganisationsCurrentResourceExplorerFiltersByFilterProviderAndFilterTypeValuesApiArg =
  {
    filterProvider: "aws",
    filterType: "region",
  };

export const getInfrastructureArchitecturePossibleRegionsThunk =
  createAsyncThunk(
    "infrastructureArchitecture/getInfrastructureArchitecturePossibleRegions",
    async (_, { dispatch }) => {
      const {
        getUsersMeOrganisationsCurrentResourceExplorerFiltersByFilterProviderAndFilterTypeValues,
      } = cloudChiprApi.endpoints;

      try {
        return await dispatch(
          getUsersMeOrganisationsCurrentResourceExplorerFiltersByFilterProviderAndFilterTypeValues.initiate(
            infrastructureArchitecturePossibleRegionsThunkArgs,
          ),
        ).unwrap();
      } catch (e) {
        // @ts-expect-error todo: fix api spec;
        enqueueSnackbarErrorAlert(e?.data?.message);
      }
    },
  );
